/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * GTM Operations for Basket component
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.3.0
 */

import { TableNameType } from '../../../../components/Table/types/tableTypes';
import { IGTMOperation } from './index';

export enum EGTMBasketSectionType {
    ACCOUNT = 'Лицевые счета',
    BILLS = 'Выставленные счета',
    EXPENSES = 'Анализатор расходов',
    MOBILE = 'Мобильная связь'
}

export enum EGTMMBasketInteractionType {
    ON = 'On',
    OFF = 'Off'
}

export enum EGTMBasketValueType {
    ACCOUNT = 'счет',
    NUMBER = 'номер'
}

export enum EGTMBasketCloseType {
    CROSS = 'Крестик',
    LINK = 'Закрыть'
}

export enum EGTMBottomMenuButtonTitleType {
    HIDE = 'Скрыть меню',
    SHOW = 'Показать меню'
}

export type TTableNameGTMBasket = TableNameType.account |
    TableNameType.bills |
    TableNameType.expensesAnalyzer;

export const MapTableNameToGTMBasketSectionType: {[key in TableNameType]?: EGTMBasketSectionType} = {
    [TableNameType.account]: EGTMBasketSectionType.ACCOUNT,
    [TableNameType.bills]: EGTMBasketSectionType.BILLS,
    [TableNameType.expensesAnalyzer]: EGTMBasketSectionType.EXPENSES,
}

export const onBasketButtonShow = (sectionType: EGTMBasketSectionType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e1',
    'event_cat': sectionType,
    'event_name': 'showElement',
    'event_param': 'Выбрано',
});

export const onBasketButtonClick = (sectionType: EGTMBasketSectionType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e2',
    'event_cat': sectionType,
    'event_name': 'clickElement',
    'event_param': 'Выбрано',
});

export const onBasketPopupSelectAllClick = (sectionType: EGTMBasketSectionType,
                                            interactionType: EGTMMBasketInteractionType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e3',
    'event_cat': `${sectionType} / popup`,
    'event_name': 'clickElement',
    'event_param': `Выбрать все / ${interactionType}`,
});

export const onBasketPopupSelectOneClick = (sectionType: EGTMBasketSectionType,
                                            interactionType: EGTMMBasketInteractionType,
                                            valueType: EGTMBasketValueType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e4',
    'event_cat': `${sectionType} / popup`,
    'event_name': 'clickElement',
    'event_param': `Выбрать ${valueType} / ${interactionType}`,
});

export const onBasketPopupSubmit = (sectionType: EGTMBasketSectionType): IGTMOperation => ({
    'event': 'addEvents_makeConversions',
    'event_id': 'd-v264-e5',
    'event_cat': `${sectionType} / popup`,
    'event_name': 'submit',
    'event_param': 'Применить',
});

export const onBasketPopupClose = (sectionType: EGTMBasketSectionType,
                                   closeType: EGTMBasketCloseType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e6',
    'event_cat': `${sectionType} / popup`,
    'event_name': 'closePopUp',
    'event_param': `${closeType}`,
});

export const onBottomMenuButtonClick = (sectionType: EGTMBasketSectionType,
                                        buttonTitle: EGTMBottomMenuButtonTitleType): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v264-e7',
    'event_cat': `${sectionType}`,
    'event_name': 'clickElement',
    'event_param': `${buttonTitle}`,
})
